var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar2Small(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99805 2V6",
    stroke: "#1956A8",
    strokeWidth: 1.99957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 2V6",
    stroke: "#1956A8",
    strokeWidth: 1.99957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9966 3.99902H4.99957C3.89524 3.99902 3 4.89426 3 5.9986V19.9956C3 21.0999 3.89524 21.9952 4.99957 21.9952H18.9966C20.1009 21.9952 20.9962 21.0999 20.9962 19.9956V5.9986C20.9962 4.89426 20.1009 3.99902 18.9966 3.99902Z",
    stroke: "#1956A8",
    strokeWidth: 1.99957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.99805H20.9962",
    stroke: "#1956A8",
    strokeWidth: 1.99957,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar2Small);
export default __webpack_public_path__ + "static/media/icon_calendar2_small.7d788e8e6d994ec98a27e043076573c8.svg";
export { ForwardRef as ReactComponent };